import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "@/components/shell/Shell";
import { LoginPage } from "@/features/login/LoginPage";
import { HomePage } from "@/features/home/HomePage";
import { RunsListPage } from "@/features/runs/RunsListPage";
import { RunDetailPage } from "@/features/runs/RunDetailPage";
import { ScenariosListPage } from "@/features/scenarios/ScenariosListPage";
import { ScenarioDetailPage } from "@/features/scenarios/ScenarioDetailPage";
import { BackendsListPage } from "@/features/backends/BackendsListPage";
import { SuitesListPage } from "@/features/suites/SuitesListPage";
import { SuiteLaunchPage } from "@/features/suites/SuiteLaunchPage";
import { SuiteDetailPage } from "@/features/suites/SuiteDetailPage";
import { RunnersListPage } from "@/features/runners/RunnersListPage";
import { TemplatesListPage } from "@/features/templates/TemplatesListPage";
import { DocsLayout } from "@/features/docs/DocsLayout";
import { DocsPage } from "@/features/docs/DocsPage";
import { SettingsPage } from "@/features/settings/SettingsPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<Shell />}>
          <Route index element={<HomePage />} />
          <Route path="/runs" element={<RunsListPage />} />
          <Route path="/runs/:runId" element={<RunDetailPage />} />
          <Route path="/scenarios" element={<ScenariosListPage />} />
          <Route path="/scenarios/:slug" element={<ScenarioDetailPage />} />
          {/* /suites/new before /suites/:suiteId so "new" is not read as an id. */}
          <Route path="/suites" element={<SuitesListPage />} />
          <Route path="/suites/new" element={<SuiteLaunchPage />} />
          <Route path="/suites/:suiteId" element={<SuiteDetailPage />} />
          <Route path="/runners" element={<RunnersListPage />} />
          <Route path="/backends" element={<BackendsListPage />} />
          <Route path="/templates" element={<TemplatesListPage />} />
          <Route path="/docs" element={<DocsLayout />}>
            <Route index element={<Navigate to="/docs/getting-started" replace />} />
            <Route path=":slug" element={<DocsPage />} />
          </Route>
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
